module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_11.78cd03ad.png";